<template>
  <div id="topic-selection">
      <div class="topic-card-section">
      <section class="card-topic-selection-section">
        <v-card-title class="header-text-bold">
        <span class="header-text-bold">{{contentData.questionfortopicselection.title}}</span>
        </v-card-title>  
          <v-card-title class="consent-privacy-text">
          <v-checkbox v-model="isConsentBoxSelected" color="#35887E" class="consent-checkbox" ></v-checkbox>
            <div @click="consentTextSelect()">Hiermit willigen Sie in die Verarbeitung von Gesundheitsdaten zum Zweck der Durchführung
              <br> und Verbesserung unserer digitalen Beratung ein. Die Einwilligung können Sie jederzeit widerrufen.<br>
              Ausführliche Informationen zur Datenverarbeitung finden Sie in den Datenschutzinformationen.   
              <br><a href="https://www.anni.care/datenschutz/" target="_blank" class="link-bottom-text">Zur Datenschutzerklärung</a>
            </div>        
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn
                    v-if="isConsentBoxSelected && selectedItem != null"      
                    :style="{ color: isConsentBoxSelected == true ? 'white' : 'grey' }" 
                    @click.native="submitAnswer()" 
                    class="bottom-next-btn text-capitalize v-btn--is-elevated">
                    Weiter
                </v-btn>
                <v-btn
                    v-else    
                    v-on="on" 
                    style="color: #B4B4B4;"
                    color="#DBDBDB"
                    class="bottom-next-btn text-capitalize v-btn--is-elevated">
                    Weiter
                </v-btn>  
            </template>
            <span> {{getTooltipText() }} </span>
          </v-tooltip>
        </v-card-title>  
                <section class="topic-cards-section">    
              <v-carousel
                  hide-delimiters
                  :continuous="false"
                >
                    <template v-for="(topic,index) in contentData.cards">
                      <v-carousel-item v-if="(index + 1) % columns === 1 || columns === 1" :key="index">
                        <v-row class="flex-nowrap" style="height: 100%">
                          <template v-for="(n, i) in columns">
                            <template v-if="index + i < contentData.cards.length">
                              <v-col :key="i" class="v-col-section">
                                <v-hover v-slot="{ hover }" open-delay="50">
                                  <v-card :elevation="hover ? 12 : 2"
                                    :class="{ 'on-hover': hover }"
                                         :color="selectedItem == index + i ? '#35887E' : 'white'" active-class="bg-active" class="v-card-section" @click.native = "selectItem(index + i)">
                                    <img :src= "contentData.cards[index + i].imgsrc" width= 100% class="cards-img" /> 
                                    <label :style="{'color':selectedItem == index + i ? 'white' : 'black'}" class="card-inner-text">{{contentData.cards[index + i].text}}</label> 
                                </v-card>
                              </v-hover>
                              </v-col>
                            </template>
                          </template>
                        </v-row>
                      </v-carousel-item>
                    </template>
                </v-carousel>
          </section>
          <div class="additional-topic bottom-text-bold"><a @click="reportAdditionalTopic()">Ihnen fehlt ein Thema?</a></div>
        </section>
     </div>   
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
      contentData: {
          questionfortopicselection :{
            title: "Zu welchem Thema möchten Sie Hilfsmittel finden?"
          },
          cards :[
          {
            text :"Mobilität / Bewegung",
            disabled: true,
            imgsrc : "",
          }
        ]
      },
      columns: 5,
      executableSystemAction: {},
      selectedItem: null,
      isConsentBoxSelected :false,
    };
  },
  methods: {
    
    // updates the question in the screen and triggers updates + visibility of required response components
    updateQuestionAndResponse(executableSystemAction){
      console.log("INSIDE TOPIC SELECTION SCREEN")
      console.log(executableSystemAction)
      

      this.executableSystemAction = executableSystemAction;

      // update title + subtitle
      this.contentData.cards = executableSystemAction.guiTemplateContent.cards;
     },

   submitAnswer(){
      let newInput = {
        cards: {},
      };    
      const selectedCardIndex = this.selectedItem; 
      
      // then we set the corresponding variable to true (based on the input interpretation context)
      newInput.cards[this.contentData.cards[selectedCardIndex]["inputInterpretationContext"]["variableName"]] = true;

      // then we need to emit the event so that the backend is called with the new information
      this.$emit("forwardAnswerToAppForBackendProcessing", newInput)
    },
    showFeatureUnavailableModal(selectedItem){
        this.$emit("showFeatureUnavailableModal", selectedItem)
      
    },
    reportAdditionalTopic() {
      this.$emit("reportNewTopicModal")
    },
    selectItem(index) {
      if(this.contentData.cards[index].disabled !== true){
        this.selectedItem = this.selectedItem === index ? null : index;
      }
      else{
        this.showFeatureUnavailableModal(this.contentData.cards[index].text);
      }
      
    },
    consentTextSelect(){
      this.isConsentBoxSelected = !this.isConsentBoxSelected ;
    },
    getTooltipText()
    {
      if(this.selectedItem == null && !this.isConsentBoxSelected)
      {
        return 'Bitte wählen Sie ein Beratungsthema aus, um fortzufahren'
      }
      else if(this.selectedItem == null)
      {
        return 'Bitte wählen Sie ein Beratungsthema aus, um fortzufahren'
      }
      else if(!this.isConsentBoxSelected)
      {
        return 'Um die Beratung zu starten, müssen Sie zunächst der Datenverarbeitung zustimmen'
      }
      return ''
    }
  },
  mounted(){
    console.log("mount TOPIC SELECTION")
      // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
      this.$nextTick(() => {
        this.$emit("readyToUpdate")
      });
  },
  destroyed(){ //TODO: switch to unmount when upgrade to Vue3
    console.log("unmount TOPIC SELECTION")
  }
};
</script>
